import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import Attachments from '../../../shared/UI/Attachments/Attachments'; 
import moment from 'moment';
import UploadImage from '../../../assets/images/uploadImg.svg';
import { apcologo} from '../../../shared/fontsAndBitImages';
import readXlsxFile from 'read-excel-file';
import { Accordion, AccordionTab } from 'primereact/accordion';
import lodash from 'lodash';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { MultiSelect } from 'primereact/multiselect';
import { blue } from '@material-ui/core/colors';



const Inputs = ({ field, metaData, onInputChange, ...props }) => {

    const Component = ImplementationFor[field.fieldType] || false;
    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={metaData}
    /> || null;

}

const MOBLIZATION_ID = 'f4116c36-7a1c-4138-89b5-9fd42ce09ff1';


class Moblization extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            processInitiated: false,
            stageSequence: 0,
            fromDate: false,
            toDate: false,
            requestDate: moment(),
            otType:false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            employees: false,
            OTHours: false,
            requestId: false,
            popupType: 'submit',
            activeIndex: false,
            requestattachments: [],
            workorderno: '',
            Reason: '',
            empnew:[],
            vendors : []
        }
        this.initialize = this.initialize.bind(this);
        this.readFromExcel = this.readFromExcel.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this);
        this.handleExcel = this.handleExcel.bind(this);
    }
    getNextWorkingDate = (otempid) => {
        this.setState({loading:true});
        const { requestedFor, fromDate } = this.state;
        //const reportingDate = moment(toDate).add(1, 'days');
        axios.get(`/master/api/GetTotalOTDone?id=${otempid}`).then(response =>{
            this.setState({loading:false});
            return response.data.OTDone
        }).catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'Total OT Hour API Failed'});
            this.setState({loading:false});
        })  
    }

    

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value,type, checked } = e.target;

        if (el) {
            let selIndex = 0;
            let selEmployees = el.fieldDescription === 'Employees' && value || [];
            const process = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage.stage_Field.map(field => {
                    let EmployeeId = null;
                    if (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') {
                        if (parseInt(selIndex) === selEmployees.length) {
                            selIndex = 0;
                        }
                        EmployeeId = selEmployees && selEmployees.length > 0 && selEmployees[selIndex] || null;
                        selIndex++;
                    }
                    return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') ? EmployeeId :(field.fieldDescription === "OT Type" && el.fieldDescription === 'OT Type') ? value : (type === 'checkbox' && field.fieldName === name) ? checked: (field.fieldDescription === "Employees" && el.fieldDescription === 'Employees') ? value.map(c => c).join(',') : field.fieldName === name ? value : (el.fieldDescription === 'OT Hours' && field.fieldDescription === 'Hours') ? value  : field.fieldValue })
                })
            }));

            this.setState({
                fromDate: el.fieldDescription === "From Date" ? value : this.state.fromDate,
                toDate: el.fieldDescription === "To Date" ? value : this.state.toDate,
                employees: el.fieldDescription === "Employees" ? value.map(c => c).join(',') : this.state.employees,
                OTHours: el.fieldDescription === "OT Hours" ? value : this.state.OTHours,
                requestDate: el.fieldDescription === "Request Date" ? value : this.state.requestDate,
                process,
                otType: el.fieldDescription === "OT Type" ? value : this.state.otType,
                workorderno: el.fieldDescription === "Work Order No." ? value : this.state.workorderno,
                Reason:el.fieldDescription === "Reason" ? value : this.state.Reason,
            });

        }
    }

    initialize = (process, type) => {
        const { tableLists, location = {} } = this.props;
        const { stageSequence, fromDate, toDate, employees, OTHours, requestDate, otType,workorderno,Reason } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;
        const empID = this.props.loggedUserDetail.empID;

        let count = 1;
        let sequence = 1;
        let start = new Date(fromDate);
        let end = new Date(toDate);

        if ((type === 'progress' && fromDate && toDate && employees && start <= end) || type === 'add' || type === 'edit' || type === 'request') {


            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if ((type === 'add' && stageIndex === 0 && (el.fieldDescription === "From Date" ||el.fieldDescription === "Work Order No." ||el.fieldDescription === "Reason" || el.fieldDescription === "To Date" || el.fieldDescription === "Employees" || el.fieldDescription === "OT Hours" || el.fieldDescription === "OT Type")) || (type === 'add' && stageIndex > 0)) {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: el.fieldDescription === "Request Date" && requestDate || el.fieldDescription === 'Requested For' && empID || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:false});
                        } else if (type === 'progress' && el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = employees.split(',');
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                                selEmployees.map(sel => {
                                    let startDate = new Date(fromDate);
                                    let endDate = new Date(toDate);
                                    if (fromDate && toDate && startDate <= endDate) {
                                        while (startDate <= endDate) {
                                            fields.map((subField) => {
                                                let formatDate = new Date(startDate);
                                                a.push(Object.assign({}, { ...subField },
                                                    {
                                                        childRowNmbr: loopIndex,
                                                        fieldName: `${startIndex}${count++}`,
                                                        fieldSequence: sequence++,
                                                        groupingfieldvalue: sel,
                                                        stageSequence: stageIndex,
                                                        stageNum: `00${stageIndex}`,
                                                        fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && sel) || (subField.fieldDescription === 'OT Type' && otType) || subField.fieldValue
                                                    }));

                                            });
                                            loopIndex++;
                                            startDate.setDate(startDate.getDate() + 1);
                                        }
                                    }

                                });

                            }
                            this.setState({processInitiated:true});

                        } else if (type === 'progress' && el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "From Date" && fromDate) ||(el.fieldDescription === "Work Order No." && workorderno) ||(el.fieldDescription === "Reason" && Reason) || (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "OT Hours" && OTHours) || (el.fieldDescription === "To Date" && toDate) || (el.fieldDescription === "Request Date" && requestDate) || (el.fieldDescription === "OT Type" && otType) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:true});
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence && pendingWith !== null ) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                                        })
                                    }
                                })
                            }
                            this.setState({processInitiated:true});
                        } else if(type === "bulkUpload"){
                            
                        }
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);

            setTimeout(this.handleExcel.bind(this), 5000);


        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }
    }
    

    readFromExcel = (vals, process) => {
        const input = document.getElementById('bulkUploadFile');
        if (input){
        const { stageSequence, requestDate, fromDate, toDate, employees, OTHours, otType,workorderno,Reason } = this.state;

        const { keywordValuesList: empList,metaData} = this.props;


        let count = 1;
        let sequence = 1;
        const empID = this.props.loggedUserDetail.empID;
        
        let empmoblizationData = [] // contains an arry of obj with each obj having empid empname month of the ot year of the ot and hour for each specific day at "hours" key
            let costcentlist = metaData["Cost Center"];
            let projectlist = metaData["Project"]
            let orglist = metaData["Department"]
            let vendorlist = metaData["Supplier"]
            let emptypelist = metaData["Employee Type"]
            let salarytypelist = metaData["Salary Type"]
            let Categorylist = metaData["Category"]
            let Gradelist = metaData["Grade"]
            let perssubarealist = metaData["Working Division (Pers Sub Area)"]
            let Genderlist = metaData["Gender"]
            let Nationalitylist = metaData["Nationality"]
            let positionlist = metaData["Position"]
            let employeesubgrouplist = metaData["Employee Sub Group"]
            let employeegrouplist = metaData["Employee Group"]
            let PayrollArealist = metaData["Payroll Area"]
            let ShiftPatternlist = metaData["Shift Pattern"]
            let Shift = metaData["Shift"]


        readXlsxFile(input.files[0]).then((otData) => {
            
            
            let otDays = otData[0].slice(4)
            var monthc = "";
            otData.forEach((row, rowIndex) => {
                if (rowIndex > 0) { // ignoring the first row since it is the header
                    otData = {}
                  console.log(Nationalitylist)
                  console.log(employeesubgrouplist)
                    otData.empId = row[1]//empList.find(emp => emp.id === parseInt(row[0]))?.value || row[0]
                    var nm =  row[2] && row[2].split(' ') 
                    otData.firstname = nm[0] && nm[0]
                    otData.middlename = nm[1] && nm[1] //row[2]
                    otData.lastname = nm[2] && nm[2] //row[3]
                    otData.nationality =row[3]!=null ?  Nationalitylist.find(na => na.id === row[3] || na.label.toLowerCase()  === row[3].toString().toLowerCase() )?.value || row[3] :row[3]
                    otData.position =row[4] //!= null ? positionlist.find(pos => pos.id === row[4] || pos.label.toLowerCase() === row[4].toString().toLowerCase())?.value : row[4] 

                    otData.department =row[5]!=null ?  orglist.find(org => org.id === row[5] || org.label.toLowerCase() === row[6].toString().toLowerCase())?.value : null //need to verify (dept )
                    otData.costcenter = row[7] !=null ? costcentlist.find(cc => cc.id === row[7] || cc.label.toLowerCase() === row[7].toString().toLowerCase())?.value : null 
                    otData.supplier =row[9]!=null ?  vendorlist.find(sup => sup.id === row[8]+'' || sup.label.toLowerCase() === row[9].toString().toLowerCase()+'')?.value : null 
                    otData.joiningdate = row[10]
                    otData.employeetype = row[11]!=null ?   emptypelist.find(gra => gra.id === row[11] || gra.id === String(row[11]) || gra.label.toLowerCase()  === row[11].toString().toLowerCase() )?.value || row[11] : row[11] 
                    otData.location = row[12]
                    otData.grade =row[13]!=null ?   Gradelist.find(gra => gra.id === row[13] || gra.label.toLowerCase() === row[13].toLowerCase())?.value || row[13] : row[13] 
                    otData.campallotted = row[14]
                    // if (row[5] == null)
                    // {
                    //     row[5] = row[0]  
                    // }
                    otData.category =row[15]!=null ?   Categorylist.find(gra => gra.id === row[15] || gra.label.toLowerCase() === row[15].toLowerCase())?.value || row[15] : row[15] 
                    otData.seniority = row[16]
                    otData.area =row[17] //row[17]!=null ? perssubarealist.find(gra => gra.id === row[17] || gra.label.toLowerCase() === row[17].toLowerCase())?.value || row[17] : row[17] 
                    otData.Acpomobno = row[18]
                    otData.DateOfBirth = row[19]
                    otData.salarytype = row[20]!=null ?   salarytypelist.find(gra => gra.id === row[20] || gra.label.toLowerCase() === row[20].toLowerCase() )?.value || row[20] : row[20] 
                    otData.shift = row[21]!=null ?  Shift.find(sp => sp.id === row[21] || sp.label.toLowerCase()  === row[21].toString().toLowerCase() )?.value || row[21] : row[21] 
                    otData.iqamano = row[22]
                    otData.iqamaexpirydatear = row[23]
                    otData.iqamaexpirydate = row[24]
                    otData.medicalcardno = row[25]
                    otData.medicalexpirydate = row[26]
                    otData.passportno = row[27]
                    otData.passportexpirydate = row[28]
                    otData.qualification = row[29]
                    otData.profession = row[30]
                    otData.sponsor = row[31]
                    otData.saudinonsaudi = row[32]
                    otData.agreement = row[33]
                    otData.agreementexpirydate = row[34]
                    otData.hourlyrate = row[35]
                    otData.Pono = row[36]
                    otData.PoItem = row[37]
                    otData.PoServiceId = row[38]
                    otData.religion = row[39]
                    otData.mobileno = row[40]
                    // otData.ShiftPattern = row[41]!=null ?   ShiftPatternlist.find(sp => sp.id === row[41] || sp.label.toLowerCase()  === row[41].toLowerCase() )?.value || row[41] : row[41] 
                    otData.ShiftPattern = row[41] != null ? ShiftPatternlist.find(sp =>  String(sp.id) === String(row[41]) ||  (sp.label && String(sp.label).toLowerCase() === String(row[41]).toLowerCase()) )?.value || row[41] : row[41];
                    console.log("Shift Pattern ",ShiftPatternlist)
                    //  tolerant mapping: normalize cell, map "female" -> "femal" then lookup by id or normalized label
                    const rawGender = row[42];
                    otData.Gender = rawGender ? (Genderlist.find(g =>  String(g.id) === String(rawGender) || (g.label && String(g.label).toLowerCase().replace(/[^a-z]/g, '') ===  String(rawGender).toLowerCase().replace(/[^a-z]/g, '').replace('female', 'femal')) )?.value || rawGender) : rawGender;
                    otData.Employeegroup = row[43]!=null ?   employeegrouplist.find(eg => eg.id === row[43] || eg.label.toLowerCase()  === row[43].toLowerCase() )?.value || row[43] : row[43]
                    otData.employeesubgroup =row[44]!=null ? employeesubgrouplist.find(esg => esg.id === row[44] || esg.label.toLowerCase()  === row[44].toLowerCase() )?.value || row[44] :row[44]
                    // otData.employeesubgroup = row[44] != null ? employeesubgrouplist.find(esg =>  String(esg.id) === String(row[44]) ||  (esg.label && String(esg.label).toLowerCase() === String(row[44]).toLowerCase()) )?.value || row[44] : row[44];
                    // otData.PayrollArea = row[45]!=null ?   PayrollArealist.find(pa => pa.id === row[45] || pa.label.toLowerCase()  === row[45].toLowerCase() )?.value || row[45] : row[45] 
                    otData.PayrollArea = row[45] != null ? PayrollArealist.find(pa =>  String(pa.id) === String(row[45]) ||  (pa.label && String(pa.label).toLowerCase() === String(row[45]).toLowerCase()) )?.value || row[45] : row[45];                    
                    // otData.ShiftPattern = row[41]!=null ?   ShiftPatternlist.find(sp => sp.id === row[41] || sp.label.toLowerCase()  === row[41].toLowerCase() )?.value || row[41] : row[41] 
                    
    //                 otData.status = row[15]
    //                 otData.cardnumber = row[16]
    //                 otData.bankname = row[34]
    //                 otData.bankaccno = row[35]
    //                 otData.terminationdate = row[40]
    // //                otData.costcenter = row[41] !=null ? costcentlist.find(pos => pos.id === row[41] || pos.label.toLowerCase() === row[4].toString().toLowerCase())?.value : row[41] 
    //                 otData.project = row[42] != null ? projectlist.find(pos => pos.id === row[42] || pos.label.toLowerCase() === row[42].toString().toLowerCase())?.value : row[42]                     
                    // otData.Gender =row[45]!=null ?  Genderlist.find(gra => gra.id === row[45] || gra.label.toLowerCase()  === row[45].toLowerCase() )?.value || row[45] :row[45]
    //                 otData.PoTodate = row[49]
    //                 otData.AcpoIdCardExpiryDate = row[51]
    //                // otData.hours = otDays.map((day, i) => [day, otHours[i]])
 
    let missingFields = [];
   // if (!otData.position || otData.position==null) missingFields.push('Position');
    if (!otData.department || otData.department==null) missingFields.push('Department');
    if (!otData.nationality || otData.nationality==null) missingFields.push('Nationality');
    if (!otData.costcenter || otData.costcenter==null ) missingFields.push('Cost Center');
    if (otData.employeetype ==='2' && (!otData.supplier || otData.supplier==null) ) missingFields.push('Supplier');
   // if (!otData.gender || otData.gender==null ) missingFields.push('Gender');
   // if (!otData.grade || otData.grade==null ) missingFields.push('Grade');
   // if (!otData.employeetype || otData.employeetype==null ) missingFields.push('Employee Type');
   // if (!otData.category || otData.category==null ) missingFields.push('Category');
   // if (!otData.seniority || otData.seniority==null ) missingFields.push('Seniority');
   // if (!otData.salarytype || otData.salarytype==null ) missingFields.push('Salary Type');
   // if (!otData.contracttype || otData.contracttype==null ) missingFields.push('Contract Type');
    //if (!otData.shift || otData.shift==null ) missingFields.push('Shift');
   // if (!otData.project || otData.project==null ) missingFields.push('Project');

    if (missingFields.length > 0) {
        this.growl.show({
            severity: 'error',
            summary: null,
            detail: `Please enter correct value of employee-`+otData.empId+`-`+ otData.firstname+ ` `+otData.middlename+`  for the following fields: ${missingFields.join(', ')}.`
        });
        return;
    }
    
    
    
                    empmoblizationData.push(otData)
                   
                }
            })


            let empnew = []

        if (empmoblizationData) {
            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = empmoblizationData;
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                            //     selEmployees.forEach(sel => {
                            //         var { religion,hourlyrate,agreementexpirydate,agreement,saudinonsaudi,medicalexpirydate,medicalcardno,seniority,Acpomobno,campallotted,empId,firstname, middlename,lastname,department,position,grade,profession,category,sponsor,workingunit,workingdivision,salarytype,contracttype,employeetype,status,cardnumber,supplier,                     nationality,address,mobileno,email,shift,visastatus,iqamano,iqamaissuedate,iqamaexpirydate,passportno,passportissuedate,passportexpirydate,visano,visatype,visaissuedate,
                            //             visaexpirydate,bankname,bankaccno,probation,appointmentdletterdate,confirmationdate,joiningdate,terminationdate,costcenter,project,DateOfBirth,Employeegroup, employeesubgroup,PayrollArea,Gender,Pono,PoItem,PoServiceId,PoTodate,AcpoIdCardNo,AcpoIdCardExpiryDate,iqamaexpirydatear,shift,ShiftPattern} = sel


                            //    let   c=  { label: firstname +' '+middlename+' ' +lastname, value: empId+'', id: empId}
                            //         empnew.push( c);
                            //             fields.map((subField) => {
                            //                 //let formatDate = new Date(year, month, otDay

                                          
                            //                 a.push(Object.assign({}, { ...subField },
                            //                     {
                            //                         childRowNmbr: loopIndex,
                            //                         fieldName: `${startIndex}${count++}`,
                            //                         fieldSequence: sequence++,
                            //                         groupingfieldvalue: sel.empId,
                            //                         stageSequence: stageIndex,
                            //                         stageNum: `00${stageIndex}`,
                            //                         // fieldValue: (subField.fieldDescription === 'Religion' && religion) || (subField.fieldDescription === 'Hourly Rate' && hourlyrate) || (subField.fieldDescription === 'Agreement Expiry Date' && agreementexpirydate) || (subField.fieldDescription === 'Agreement' && agreement) || (subField.fieldDescription === 'Saudi Or Non Saudi' && saudinonsaudi) || (subField.fieldDescription === 'Medical Expiry Date' && medicalexpirydate) || (subField.fieldDescription === 'Medical Card Number' && medicalcardno) || (subField.fieldDescription === 'Seniority' && seniority) || (subField.fieldDescription === 'Apco Mobile#' && Acpomobno) || (subField.fieldDescription === 'Camp Allotted' && campallotted) || (subField.fieldDescription === 'First Name' && firstname) || (subField.fieldDescription === 'Middle Name' && middlename) || (subField.fieldDescription === 'Last Name' && lastname) || (subField.fieldDescription === 'Department' && department) || (subField.fieldDescription === 'Position' && position) || (subField.fieldDescription === 'Grade' && grade) || (subField.fieldDescription === 'Profession' && profession) || (subField.fieldDescription === 'Category' && category ) || (subField.fieldDescription === 'Salary Type' && salarytype) || (subField.fieldDescription === 'Contract Type' && contracttype) || (subField.fieldDescription === 'Employee Type' && employeetype) || (subField.fieldDescription === 'Shift' && shift) || (subField.fieldDescription === 'Supplier' && supplier) || (subField.fieldDescription === 'Nationality' && nationality)  || (subField.fieldDescription === 'Mobile No' && mobileno) ||  (subField.fieldDescription === 'Shift' && shift) ||  (subField.fieldDescription === 'Iqama number' && iqamano) || (subField.fieldDescription === 'Iqama Issue Date' && iqamaissuedate) || (subField.fieldDescription === 'Iqama Expiry Date' && iqamaexpirydate) || (subField.fieldDescription === 'Iqama Expiry Date Arabic' && iqamaexpirydatear) || (subField.fieldDescription === 'Passport Number' && passportno) || (subField.fieldDescription === 'Passport Issue Date' && passportissuedate ) || (subField.fieldDescription === 'Passport Expiry Date' && passportexpirydate) ||  (subField.fieldDescription === 'Joining Date' && joiningdate) || (subField.fieldDescription === 'Cost Center' && costcenter) || (subField.fieldDescription === 'Sponsor' && sponsor) || (subField.fieldDescription === 'Gender' && Gender)  || (subField.fieldDescription === 'Date Of Birth' && DateOfBirth)  || (subField.fieldDescription === 'Date Of Birth' && DateOfBirth) || (subField.fieldDescription === 'Project' && project) || (subField.fieldDescription === 'PO Number' && Pono) || (subField.fieldDescription === 'PO Item Number' && PoItem) || (subField.fieldDescription === 'PO Service ID' && PoServiceId) || (subField.fieldDescription === 'Shift Pattern' && ShiftPattern) || (subField.fieldDescription === 'Employee Id' && empId) || subField.fieldValue  
                            //                         fieldValue: (subField.fieldDescription === 'Religion' && religion) || (subField.fieldDescription === 'Hourly Rate' && hourlyrate) || (subField.fieldDescription === 'Agreement Expiry Date' && agreementexpirydate) || (subField.fieldDescription === 'Agreement' && agreement) || (subField.fieldDescription === 'Saudi Or Non Saudi' && saudinonsaudi) || (subField.fieldDescription === 'Medical Expiry Date' && medicalexpirydate) || (subField.fieldDescription === 'Medical Card Number' && medicalcardno) || (subField.fieldDescription === 'Seniority' && seniority) || (subField.fieldDescription === 'Apco Mobile#' && Acpomobno) || (subField.fieldDescription === 'Camp Allotted' && campallotted) || (subField.fieldDescription === 'First Name' && firstname) || (subField.fieldDescription === 'Middle Name' && middlename) || (subField.fieldDescription === 'Last Name' && lastname) || (subField.fieldDescription === 'Department' && department) || (subField.fieldDescription === 'Position' && position) || (subField.fieldDescription === 'Grade' && grade) || (subField.fieldDescription === 'Profession' && profession) || (subField.fieldDescription === 'Category' && category ) || (subField.fieldDescription === 'Salary Type' && salarytype) || (subField.fieldDescription === 'Contract Type' && contracttype) || (subField.fieldDescription === 'Employee Type' && employeetype) || (subField.fieldDescription === 'Shift' && shift) || (subField.fieldDescription === 'Supplier' && supplier) || (subField.fieldDescription === 'Nationality' && nationality)  || (subField.fieldDescription === 'Mobile No' && mobileno) ||  (subField.fieldDescription === 'Shift' && shift) ||  (subField.fieldDescription === 'Iqama number' && iqamano) || (subField.fieldDescription === 'Iqama Issue Date' && iqamaissuedate) || (subField.fieldDescription === 'Iqama Expiry Date' && iqamaexpirydate) || (subField.fieldDescription === 'Iqama Expiry Date Arabic' && iqamaexpirydatear) || (subField.fieldDescription === 'Passport Number' && passportno) || (subField.fieldDescription === 'Passport Issue Date' && passportissuedate ) || (subField.fieldDescription === 'Passport Expiry Date' && passportexpirydate) ||  (subField.fieldDescription === 'Joining Date' && joiningdate) || (subField.fieldDescription === 'Cost Center' && costcenter) || (subField.fieldDescription === 'Sponsor' && sponsor) || (subField.fieldDescription === 'Gender' && Gender)  || (subField.fieldDescription === 'Date Of Birth' && DateOfBirth)  || (subField.fieldDescription === 'Date Of Birth' && DateOfBirth) || (subField.fieldDescription === 'Project' && project) || (subField.fieldDescription === 'PO Number' && Pono) || (subField.fieldDescription === 'PO Item Number' && PoItem) || (subField.fieldDescription === 'PO Service ID' && PoServiceId) || (subField.fieldDescription === 'Shift Pattern' && ShiftPattern) || (subField.fieldDescription === 'Employee Id' && empId) ||(subField.fieldDescription === 'Employee Group' && Employeegroup) || (subField.fieldDescription === 'Employee Sub Group' && employeesubgroup) || (subField.fieldDescription === 'Payroll Area' && PayrollArea) || subField.fieldValue  
                            //                     }));

                            //             });
                            //             loopIndex++;
                                 
                            //     });

                            }
                            this.setState({processInitiated:true});

                        }else if (el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "From Date" && fromDate) ||(el.fieldDescription === "Work Order No." && workorderno) ||(el.fieldDescription === "Reason" && Reason) || (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "OT Hours" && OTHours) || (el.fieldDescription === "To Date" && toDate) || (el.fieldDescription === "Request Date" && requestDate) || (el.fieldDescription === "OT Type" && otType) || (el.fieldDescription === 'Requested For' && empID) ||  el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:true});
                        } 
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues,empnew: empnew }), 3000);

            setTimeout(this.readFromExcel.bind(this), 5000);


        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

        })

    }


    }



    handleExcel = () => {
        const input = document.getElementById('file-8');
        if (input) {
            input.addEventListener('change', () => {
                this.setState({ loading: true });
                const { keywordValuesList: empList} = this.props;
                const { initialData, stageSequence, requestDate } = this.state;

                let count = 1;
                let sequence = 1;
                let EmployeeList = [];
                let FromDate = false;
                let ToDate = false;

                const process = initialData.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    return Object.assign({}, { ...stage }, {
                        stage_Field: stageField.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, el.fieldName.length - 1);
                            if (el.fieldType === '9') {
                                const container = stageField.find(_ => _.fieldType === '9');
                                const name = container.fieldName;
                                const fields = stageField.filter(_ => _.parentFieldId === name);

                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));


                                readXlsxFile(input.files[0]).then((rows) => {
                                    let loopIndex = 0;
                                    rows.map((row, rowIndex) => {
                                        let selEmployee = rows[0]
                                        let month = rows[2]
                                        let year = rows[3]
                                        if (rowIndex > 0) {
                                            row.map((el, i) => {
                                                if (i > 3 && selEmployee && month && year ) {
                                                    let formatDate = new Date(moment(`${month}, ${rows[0][i]} ${year}`));
                                                    let OTHours = (el === null || el === 'null') ? '0' : el.toString();
                                                    FromDate = (i === 4 && rowIndex === 1) && formatDate || FromDate;
                                                    ToDate = (i === (row.length - 1) && rowIndex === 1) && formatDate || ToDate;

                                                    const emps = fields.map((subField) => ({
                                                                childRowNmbr: loopIndex,
                                                                fieldName: `${startIndex}${count++}`,
                                                                fieldSequence: sequence++,
                                                                groupingfieldvalue: selEmployee.value,
                                                                fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && selEmployee && selEmployee.value) || subField.fieldValue,
                                                                stageSequence: stageIndex, 
                                                                stageNum: `00${stageIndex}`
                                                            }))


                                                    
                                                    EmployeeList.push(selEmployee);
                                                    fields.map((subField) => {
                                                        a.push(Object.assign({}, { ...subField },
                                                            {
                                                                childRowNmbr: loopIndex,
                                                                fieldName: `${startIndex}${count++}`,
                                                                fieldSequence: sequence++,
                                                                groupingfieldvalue: selEmployee.value,
                                                                fieldValue: (subField.fieldDescription === 'OT Date' && formatDate) || (subField.fieldDescription === 'Hours' && OTHours) || (subField.fieldDescription === 'Employee Id' && selEmployee && selEmployee.value) || subField.fieldValue,
                                                                stageSequence: stageIndex, 
                                                                stageNum: `00${stageIndex}`
                                                            }));

                                                    });
                                                    loopIndex++;
                                                }

                                            })

                                            
                                        }
                                    })
                                })


                            } else if (el.parentFieldId === '000') {
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: el.fieldDescription === 'Request Date' && requestDate || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            }
                            return a;
                        }, [])
                    })
                });


                if (process && process.length > 0)
                    setTimeout(() => {
                        this.setState({ loading: false, process, employees: EmployeeList && Array.isArray(EmployeeList) && EmployeeList.length > 0 ? [...new Set(EmployeeList.map(e => e.value))].join(',') : [], fromDate: FromDate, toDate: ToDate })
                    }, 4000);

            })
        }

    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
        this.setState({requestattachments:attachmentData});
    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process, fromDate, toDate, employees, processInitiated,workorderno,Reason } = this.state;
        const type = this.props.match.params.type;

        if(!processInitiated){
            this.growl.show({ severity: 'error', summary: null, detail: 'Please Initiate before Submitting/Saving' });
            this.setState({ loading: false })
            return;
        }

        let FromDate = fromDate;
        let ToDate = toDate;
        let Workordernum = workorderno;
        let reason = Reason;
        let RequestDate = new Date();
        let Comment = '';
        let RequestAttributes = [];
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {
                if (el.fieldDescription === 'From Date') {
                    el.fieldValue = fromDate || el.fieldValue;
                    FromDate = el.fieldValue || FromDate; 
                } else if (el.fieldDescription === 'To Date') {
                    el.fieldValue = toDate || el.fieldValue;
                    ToDate = el.fieldValue || ToDate;
                } else if (el.fieldDescription === 'Employees') {
                    el.fieldValue = employees || el.fieldValue;
                } else if (el.fieldDescription === 'Request Date' && el.fieldValue) {
                    RequestDate = el.fieldValue;
                } else if (el.fieldDescription === 'Comment' && stageIndex === 0) {
                    Comment = el.fieldValue;
                }else if (el.fieldDescription === 'Work Order No.') {
                    el.fieldValue = workorderno || el.fieldValue;
                    Workordernum = el.fieldValue || Workordernum;
                }else if (el.fieldDescription === 'Reason') {
                    el.fieldValue = toDate || el.fieldValue;
                    reason = el.fieldValue || reason;
                }
                
                RequestAttributes.push(Object.assign({}, {...el}, {fieldValue: (el.fieldType === "7" || el.fieldType === "8" || (el.fieldType === "1" && el.fieldStatus === "Display Only")) ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue}));
            })
        });



        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Moblization Request',
            IsActive: true,
            RequestDate: RequestDate && moment(RequestDate),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: MOBLIZATION_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'Moblization';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'Moblization';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'Moblization';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'Moblization';
            }
            

            if (submitType === 'cancel') {
                model = 'Moblization';
            }

            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            
            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });
            
            axios.post(url, JSON.stringify(datas))
                .then(response => {
                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                    })
                                }

                                if(submitType === 'return'){
                                    this.setState({popupType: 'return'});
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'Moblization request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Moblization request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed' });
                })

        }

    }

    componentDidMount() {
        const { getContainerData, getMasterKeywordList, getKeywordValues, fetchSubordinatesLists, loggedUserDetail, location = {} } = this.props;
        const type = this.props.match.params.type;
        getContainerData(MOBLIZATION_ID);//Get Container Data
        getMasterKeywordList('Shift');// Get Shift Dropdown list
        getKeywordValues('Employee');//Get Employee Dropdown list
        getMasterKeywordList('OTType');//Get Employee Dropdown list
        getMasterKeywordList('OrgUnit');//Get Employee Dropdown list
        getMasterKeywordList('employeegroup/keyword');//Get Employee Dropdown list
        getMasterKeywordList('employeesubgroup/keyword');//Get Employee Dropdown list
        getMasterKeywordList('CostCenter');//Get Employee Dropdown list
        // getMasterKeywordList('Costcenterapco/keyword');//Get Employee Dropdown list
        getMasterKeywordList('Vendor');//Get Employee Dropdown list
        getMasterKeywordList('EMPLOYEETYPE');//Get Employee Dropdown list
        getMasterKeywordList('PayType');//Get Employee Dropdown list
        getMasterKeywordList('EmpCategory');//Get Employee Dropdown list
        getMasterKeywordList('EmpGrade');//Get Employee Dropdown list
        getMasterKeywordList('EmpPersSubArea');//Get Employee Dropdown list
        getMasterKeywordList('GENDER');//Get Employee Dropdown list
        getMasterKeywordList('Orgunit');//Get Employee Dropdown list

        getMasterKeywordList('EMPLOYEETYPE');//Get Employee Dropdown list
        getMasterKeywordList('PayType');//Get Employee Dropdown list
        getMasterKeywordList('EmpCategory');//Get Employee Dropdown list
        getMasterKeywordList('nationality/keyword');//Get Employee Dropdown list
        getMasterKeywordList('position');//Get Employee Dropdown list
        getMasterKeywordList('Project');//Get Employee Dropdown list
        getMasterKeywordList('ShiftPattern');// Get Shift Dropdown list

       
        getMasterKeywordList('payrollarea/keyword');//Get Employee Dropdown list
        
        

        if (type != 'edit') {
            fetchSubordinatesLists(loggedUserDetail.empID, loggedUserDetail.CompanyId);//Fetch subordinate api list
        }

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists = {}, containerData } = this.props;
            const { employeeID, companyID } = tableLists;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({requestattachments});

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || [];
            }

            if (process && process.length > 0 && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                
                if (employeeID && companyID)
                    fetchSubordinatesLists(employeeID, companyID);//Fetch subordinate api list
                
                clearTimer();
            }
        }, 300);


    }

    handleMethods(type) {
        this.setState({ popupType: type });
        const { keywordValuesList } = this.props;
        this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesList })
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, keywordValuesList: [], subordinatesListData: [] })
    }

    handleTabChange(e) {
        this.setState({ loading: true, activeIndex: e.index })
        setTimeout(() => this.setState({ loading: false }), 3000);
    }

    downloadOtTemplate() {
        axios({
            url: `/master/api/Download?filename=Mobilization.xlsx&&FolderName=Moblization&&ext=.xlsx`,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Mobilization.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.setState({loading: false})
          }).catch((err) => {
            this.growl.show({ severity: 'error', summary: 'null', detail: 'File Download failed, please try again.' });
          })
    }
    
    downloadPDF = () => {
        const vendors = this.state.vendors;
       
        
        const supplierslist = [];
        const suppliersprops = this.props.metaData.Supplier
        // suppliersprops.forEach(item => {
        //     vendors.forEach(sup => {
        //     if (item.value === sup) {
        //         supplierslist.push(
        //             item.label
        //         )
        //     }

        //     })
        // })

        vendors.forEach((vendor) => {
        // Initialize jsPDF instance
        const doc = new jsPDF('p', 'mm', 'a4'); // Portrait, millimeters, A4 size
        const type = "download";
        
        const suppliersprops = this.props.metaData.Supplier
        var vendorName = '';
        suppliersprops.forEach(item => {
            
            if (item.value === vendor) {
                
                  vendorName =  item.label;
                
            }

           
        })
        
        const process = this.state.process;
        const stage_Field = process[0]?.stage_Field || [];
        
        const requestDate = stage_Field.find(
            field => field.fieldDescription === "Request Date" 
            );

        const parentfieldids = [];
        stage_Field.forEach(item => {
            if (item.fieldDescription === "Supplier"){
                if (item.fieldValue === vendor){
                    parentfieldids.push(
                        item.parentFieldId
                    )

                }
            }
        })
        
        var employeeRecords = []; // This will store details of all employees

        parentfieldids.forEach(employee => {
            let employeeRecord = {}; // Create an object to store this employee's details
             
            stage_Field.forEach(item => {
                if (item.parentFieldId === employee) {
                    if (item.fieldDescription === "First Name") {
                        employeeRecord.firstName = item.fieldValue; // Add First Name
                    } else if (item.fieldDescription === "Middle Name") {
                        employeeRecord.middleName = item.fieldValue; // Add Middle Name
                    } else if (item.fieldDescription === "Last Name") {
                        employeeRecord.lastName = item.fieldValue; // Add Last Name
                    } else if (item.fieldDescription === "Department") {
                        employeeRecord.department = item.reportvalue; // Add Department
                    } else if (item.fieldDescription === "Hourly Rate") {
                        employeeRecord.HrRate = item.fieldValue; // Add Department
                    } else if (item.fieldDescription === "Nationality") {
                        employeeRecord.nationality = item.fieldValue; // Add Department
                    } else if (item.fieldDescription === "Iqama number") {
                        employeeRecord.iqamaNo = item.fieldValue; // Add Department
                    } else if (item.fieldDescription === "Apco Mobile#") {
                        employeeRecord.ApcoNo = item.fieldValue; // Add Department
                    }

                }
            });

            if (Object.keys(employeeRecord).length > 0) {
                employeeRecords.push(employeeRecord); // Push the completed record into the array
            }
        });
        
    
        const today = new Date();
        const todayFormatted = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1)
                .toString()
                .padStart(2, '0')}-${today.getFullYear()}`; 
        try {
            doc.autoTable({
                theme: 'plain', 
                startY: 9,
                margin: {
                    left: 0
                },
                columnStyles: {
                    0: { cellWidth: 50 }, // Adjust logo column width
                    1: { cellWidth: 200 } // Adjust text column width to shift text
                },
                body: [
                    [
                        { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                        {
                            content: "ARABIAN PIPE COATING COMPANY",
                            styles: {
                                halign: 'left',
                                valign: 'middle',
                                fontStyle: 'bold', 
                                fontSize: 14, 
                                textColor: 'black',
                                cellPadding: { top: 5, left: 6, right: 0 }, 
                                borderColor: 'white',
                                lineHeight: 1.2
                            }
                        }
                    ],
                    [
                        { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                        {
                            content: "CONTRACT MOBILIZATION FORM",
                            styles: {
                                halign: 'left',
                                valign: 'middle',
                                fontStyle: 'normal', 
                                fontSize: 10, 
                                textColor: 'black',
                                cellPadding: { top: 0, left: 6, right: 0 }, 
                                borderColor: 'white',
                                lineHeight: 1.2
                            }
                        }
                    ]
                ]
            });
            
            // Add the logo separately
            doc.addImage(apcologo, 'PNG', 10, 10, 40, 20); // Adjust position and size as needed
            

           // Define the outer rectangle
            doc.setDrawColor(0, 0, 0); // Set border color to black
            doc.setLineWidth(0.5);
            doc.rect(147, 3, 52, 25); // Adjusted width and height to match the box in the image

            // Add text inside the box with proper alignment and spacing
            doc.setFont('Helvetica', 'bold');
            doc.setFontSize(9); // Adjusted font size for better fit
            doc.text("Form No.", 148, 9); // Left-aligned text for "Form No."
            doc.text("HRF-009 / June/09/01", 166, 9); // Right-aligned value for Form No.

            doc.text("REVISION", 148, 16); // Left-aligned text for "REVISION"
            doc.text("", 187, 16, { align: 'right' }); // Right-aligned value for REVISION

            doc.text("PAGE NO.", 148, 23); // Left-aligned text for "PAGE NO."
            doc.text("1 OF 1", 187, 23, { align: 'right' }); // Right-aligned value for PAGE NO.

            // Draw horizontal dividers inside the box
            doc.setLineWidth(0.25);
            doc.line(148, 12, 198, 12); // Line after Form No.
            doc.line(148, 19, 198, 19); // Line after REVISION

            doc.line(165, 3, 165, 28);

            // Draw a horizontal separator line across the page
            doc.setLineWidth(0.5);
            doc.line(10, 30, 200, 30);

            // Draw the table content from the image
            doc.setDrawColor(0, 0, 0); // Set border color to black
            doc.setLineWidth(0.5);

            // Define starting X and Y coordinates for the table
            const tableX = 10; // Align with the outerBoxX
            const tableY = 31; // Right after the horizontal line at Y = 30
            const tableWidth = 190; // Align with outerBoxWidth

            // Define the row height
            const rowHeight = 8;

            // Define column widths
            const colWidths = [30, 50, 50, 60];

            // Draw the header row
            doc.rect(tableX, tableY, colWidths[0], rowHeight);
            doc.text("Today's Date", tableX + 2, tableY + 6);

            doc.rect(tableX + colWidths[0], tableY, colWidths[1], rowHeight);
            doc.text(todayFormatted, tableX + colWidths[0] + 2, tableY + 6);

            doc.rect(tableX + colWidths[0] + colWidths[1], tableY, colWidths[2], rowHeight);
            doc.text("Contract Company Name:", tableX + colWidths[0] + colWidths[1] + 2, tableY + 6);

            doc.rect(tableX + colWidths[0] + colWidths[1] + colWidths[2], tableY, colWidths[3], rowHeight);
            doc.text(vendorName, tableX + colWidths[0] + colWidths[1] + colWidths[2] + 2, tableY + 6);

            // Draw the second row
            doc.rect(tableX, tableY + rowHeight, colWidths[0], rowHeight);
            doc.text("Contact Person", tableX + 2, tableY + rowHeight + 6);

            doc.rect(tableX + colWidths[0], tableY + rowHeight, colWidths[1], rowHeight);
            doc.text("Mian Naveed", tableX + colWidths[0] + 2, tableY + rowHeight + 6);

            doc.rect(tableX + colWidths[0] + colWidths[1], tableY + rowHeight, colWidths[2], rowHeight);
            doc.text("Fax No:", tableX + colWidths[0] + colWidths[1] + 2, tableY + rowHeight + 6);

            doc.rect(tableX + colWidths[0] + colWidths[1] + colWidths[2], tableY + rowHeight, colWidths[3], rowHeight);
            doc.text("3624342", tableX + colWidths[0] + colWidths[1] + colWidths[2] + 2, tableY + rowHeight + 6);

            // Draw the third row
            doc.rect(tableX, tableY + rowHeight * 2, colWidths[0], rowHeight);
            doc.text("Mobilization Date:", tableX + 2, tableY + rowHeight * 2 + 6);

            doc.rect(tableX + colWidths[0], tableY + rowHeight * 2, colWidths[1], rowHeight);
            doc.text(requestDate.fieldValue, tableX + colWidths[0] + 2, tableY + rowHeight * 2 + 6);


            // Define the headers for the table
            // Define the headers for the table
            // const tableHeaders = [["","","","","","Record Assigned","Initial Box","Initial Box","Record P-Pass & Initial P- Rejected & Iinitial","",""],["Employee Name", "Iqama No","Sap ID","Nationality","Mobilization Trade","Department","Id  Test","HSE", "Trade Test", "Rate/Hr", "APCO Emp No"]];
            const processArray = this.state.process.slice(1); // Skip the 0th element
            const approvers = [];

            processArray.forEach((item, index) => {
                if (item.description) {
                    if (!item.description.includes(',')) {
                        // If no comma, mark as "Auto Approved"
                        approvers[index] = {
                            "employee number": "Auto Approved",
                            "employee name": "Auto Approved",
                            "position": "Auto Approved",
                            "date and time": "Auto Approved"
                        };
                    } else {
                        // Process normally if there are commas
                        const parts = item.description.split(',').map(part => part.trim());
                        const employeeNumber = parts[0].replace("Released By:", "").trim();
                        const employeeName = parts[1].split('-')[0].trim();
                        const position = parts[2].trim();
                        const dateTime = parts[3].replace("Release Date:", "").trim();

                        approvers[index] = {
                            "employee number": employeeNumber,
                            "employee name": employeeName,
                            "position": position,
                            "date and time": dateTime
                        };
                    }
                }
            });

            // Map employee records into rows for the table
            const tableData = employeeRecords.map((record) => [
                `${record.firstName || ""} ${record.middleName || ""} ${record.lastName || ""}`.trim(),
                record.iqamaNo || "",
                "",
                record.nationality || "",
                "",
                record.department || "",
                "",
                "",
                "",
                record.HrRate || "",
                record.ApcoNo || ""
            ]);

            const tableData2 = approvers.map((record, index) => [
                index + 1,
                record["employee number"],
                record["employee name"],
                record["position"],
                record["date and time"]
            ]);

            // Check if there are employee records to display
            if (tableData.length > 0) {

                doc.autoTable({
                    head: [
                        [
                            { content: "", styles: { fontSize: 7 } },
                            { content: "", styles: { fontSize: 7 } },
                            { content: "", styles: { fontSize: 7 } },
                            { content: "", styles: { fontSize: 7 } },
                            { content: "", styles: { fontSize: 7 } },
                            { content: "Record Assigned", styles: { fontSize: 7 } },
                            { content: "Initial Box", styles: { fontSize: 7 } },
                            { content: "Initial Box", styles: { fontSize: 7 } },
                            { content: "Record P-Pass & Initial P- Rejected & Initial", styles: { fontSize: 7 } },
                            { content: "", styles: { fontSize: 7 } },
                            { content: "", styles: { fontSize: 7 } }
                        ],
                        [
                            { content: "Employee Name", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Iqama No", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Sap ID", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Nationality", styles: { fontSize: 10 },fontStyle: 'bold' },
                            { content: "Mobilization Trade", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Department", styles: { fontSize: 10 }, fontStyle: 'bold'},
                            { content: "ID Test", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "HSE", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Trade Test", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Rate/Hr", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "APCO Emp No", styles: { fontSize: 10 }, fontStyle: 'bold' }
                        ]
                    ],
                    body: tableData,
                    startY: tableY + rowHeight * 3 + 10, // Adjust Y-position
                    margin: { left: 10 },
                    theme: 'grid', // Creates the grid-like style
                    headStyles: {
                        fillColor: [255, 255, 255], // White background
                        textColor: [0, 0, 0], // Black text
                        // fontStyle: 'bold', // Bold header text
                        halign: 'center' // Center alignment for header
                    },
                    bodyStyles: {
                        textColor: [0, 0, 0], // Black text
                        halign: 'center', // Center align text in cells
                        valign: 'middle' // Vertically align text in the middle
                    },
                    styles: {
                        lineWidth: 0.5, // Thin borders
                        lineColor: [0, 0, 0], // Black border color
                        fontSize: 8, // Font size for table content
                    },
                    columnStyles: {
                        0: { cellWidth: 20 }, // Employee Name
                        1: { cellWidth: 20 }, // Iqama No
                        2: { cellWidth: 15 }, // Sap ID
                        3: { cellWidth: 22 }, // Nationality
                        4: { cellWidth: 20 }, // Mobilization Trade
                        5: { cellWidth: 20 }, // Department
                        6: { cellWidth: 12 }, // Id Test
                        7: { cellWidth: 15 }, // HSE
                        8: { cellWidth: 15 }, // Trade Test
                        9: { cellWidth: 12 }, // Rate/Hr
                        10: { cellWidth: 20 } // APCO Emp No
                    }
                });
            } else {
                // Add a message if no employee records are available
                doc.text("No employee records found.", tableX, tableY + rowHeight * 3 + 10);
            }
            
            if (tableData2.length > 0) {

                doc.setFillColor(255, 255, 255); // White background
                doc.rect(10, doc.lastAutoTable.finalY + 5, 190, 10, 'F'); // Draw rectangle
                doc.setTextColor(21, 96, 189); // Black text color
                doc.setFontSize(12);
                doc.setFont("helvetica", "bold");
                doc.text("APPROVERS", 105, doc.lastAutoTable.finalY + 12, { align: "center" });

                doc.autoTable({
                    head: [
                        
                        [
                            { content: "S.no", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Employee Number", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Employee Name", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Position", styles: { fontSize: 10 }, fontStyle: 'bold' },
                            { content: "Date and Time", styles: { fontSize: 10 }, fontStyle: 'bold' },
                        ]
                    ],
                    body: tableData2,
                    startY: doc.lastAutoTable.finalY + 14,// Adjust Y-position
                    margin: { left: 10 },
                    theme: 'grid',// Creates the grid-like style
                    headStyles: {
                        fillColor: [255, 255, 255],// White background
                        textColor: [0, 0, 0], // Black text
                        // fontStyle: 'bold', // Bold header text
                        halign: 'center' // Center alignment for header
                    },
                    bodyStyles: {
                        textColor: [0, 0, 0], // Black text
                        halign: 'center', // Center align text in cells
                        valign: 'middle' // Vertically align text in the middle
                    },
                    styles: {
                        lineWidth: 0.5, // Thin borders
                        lineColor: [0, 0, 0], // Black border color
                        fontSize: 8, // Font size for table content
                    },
                    columnStyles: {
                        0: { cellWidth: 28 }, // S.no
                        1: { cellWidth: 38 }, // Employee Number
                        2: { cellWidth: 43 }, // Employee Name
                        3: { cellWidth: 43 }, // Position
                        4: { cellWidth: 39 }  // Date and Time (slightly wider to match total width)
                    }
                });
            } 

            doc.setTextColor(0, 0, 0);       
            doc.setDrawColor(0, 0, 0); // Set border color to black
            doc.setLineWidth(0.5);

            // Outer box dimensions
            const outerBoxX = 10; // Starting X-coordinate of the box
            const outerBoxY = 265; // Starting Y-coordinate of the box
            const outerBoxWidth = 190; // Total width of the box
            const outerBoxHeight = 40; // Total height of the box

            // Draw the outer rectangle
            doc.rect(outerBoxX, outerBoxY, outerBoxWidth, outerBoxHeight);

            // Define dimensions for the footer
            const footerX = 10; // Starting X-coordinate of the footer
            const footerY = 265; // Starting Y-coordinate of the footer
            const footerWidth = 100; // Width of the section
            const footerHeight = 40; // Total height of the footer box

            // Draw the main outer rectangle for the section
            doc.rect(footerX, footerY, footerWidth, footerHeight); // Outer rectangle

            // Text for "DRAWN BY", etc.
            doc.setFontSize(8);
            doc.text("DRAWN BY     : FAF", footerX + 2, footerY + 6);
            doc.text("CHECKED BY   : BB", footerX + 2, footerY + 12);
            doc.text("APPROVED BY : KHD", footerX + 2, footerY + 18);
            doc.text("DATE                : 28-04-2009", footerX + 2, footerY + 24);

            // Draw the vertical divider on the right of this section
            const verticalDividerX = footerX + 40; // Adjust as per spacing requirement
            doc.line(verticalDividerX, footerY, verticalDividerX, footerY + footerHeight);

            // Add "FORMS REV'S BY DATE" text
            doc.text("FORMS REV'S         BY            DATE", verticalDividerX + 2, footerY + 6);

            // Draw the first horizontal line below "FORMS REV'S"
            const horizontalLine1Y = footerY + 8; // Y-coordinate for the first line
            doc.line(verticalDividerX, horizontalLine1Y, footerX + footerWidth, horizontalLine1Y);

            // Add "0 FAF 28-04-2009" text
            doc.text("0                             FAF          28-04-2009", verticalDividerX + 2, footerY + 14);

            // Draw the second horizontal line below "0 FAF 28-04-2009"
            const horizontalLine2Y = footerY + 16; // Y-coordinate for the second line
            doc.line(verticalDividerX, horizontalLine2Y, footerX + footerWidth, horizontalLine2Y);

            // Leave some empty space (for future content)

            // Draw the third horizontal line for the next section
            const horizontalLine3Y = footerY + 24; // Y-coordinate for the third line
            doc.line(verticalDividerX, horizontalLine3Y, footerX + footerWidth, horizontalLine3Y);

            // Draw the vertical divider on the right of this entire section
            const rightDividerX = footerX + footerWidth; // Right side of the footer box
            doc.line(rightDividerX, footerY, rightDividerX, footerY + footerHeight);

            // The right-hand side space is left empty for further instructions

            // // Draw the first vertical divider
            // doc.line(150, footerY, 150, footerY + footerHeight);
            doc.line(rightDividerX + 36, footerY, rightDividerX + 36, footerY + footerHeight);
            // Draw the second vertical divider
            doc.line(rightDividerX + 70, footerY, rightDividerX + 70, footerY + footerHeight);

            // Add labels for the bottom section
            doc.text("Public Relation Manager", rightDividerX + 2, footerY + 30);
            doc.text("Raised By HR Recruiter", rightDividerX + 37, footerY + 30);
            doc.text("Approved By", rightDividerX + 71, footerY + 30);

            // Draw horizontal dividers

            
            
            // Output PDF based on type
            if (!['print', 'view', 'download', 'upload'].includes(type)) {
                throw new Error("Invalid type specified");
            }
                
    
            // Handle the action based on the type
            switch (type) {
                case 'print':
                    doc.autoPrint();
                    window.open(doc.output('bloburl'), '_blank');
                    break;
                case 'view':
                    window.open(doc.output('bloburl'), '_blank');
                    break;
                case 'download':
                    doc.save('mobilization_Form '+vendorName+ '.pdf');
                    break;
                default:
                    console.error('Invalid action type');
            }
    
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    })
    };

    Change = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value }); // Update state with selected values
    };

    render() {
        const { tableLists, subordinatesListData = [], location = {}, keywordValuesList: empList = [] } = this.props;
        const { state = {} } = location;
        const { fromDate, toDate, process, stageSequence, employees,Reason,workorderno,empnew } = this.state; 
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;

        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );

        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Moblization
                            <Link to={'/Moblization'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>

                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field = [], description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    const containers = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId != '000'), 'groupingfieldvalue'));
                    const suppliersprops = this.props.metaData.Supplier
                    const process_suppliers = [];
                    const supplieroptions = [];
                    // Loop through each item in process[0].stage_Field
                    process[0].stage_Field.forEach(item => {
                        // Check if fieldDescription is "Supplier"
                        if (item.fieldDescription === "Supplier") {
                            // Take fieldValue and add to process_suppliers
                            process_suppliers.push(item.fieldValue);
                        }
                    });

                    // Remove duplicates from process_suppliers
                    const unique_suppliers = [...new Set(process_suppliers)];
                    
                    suppliersprops.forEach(item => {
                        unique_suppliers.forEach(sup => {
                        if (item.value === sup) {
                            supplieroptions.push({
                                label: item.label,
                                value: item.value
                            })
                        }

                        })
                    })
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {stageIndex === 0 ? 
                                <div className="p-col-12">
                                    <div className="p-col-12">
                                        <input type="file" name="employeesAttachment" id="bulkUploadFile" className="inputfile inputfile-6 " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"  onChange={(e) => {
                                        const file = e.target.files[0];
                                        this.readFromExcel(file, this.state.initialData);
                                        }}/>
                                        <label htmlFor="bulkUploadFile"><span></span> <strong><img src={UploadImage} alt="upload im" /> Upload Moblization File&hellip;</strong></label>                         
                                    </div>
                                    <div className="p-col-3">
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.downloadOtTemplate()} label="Download Moblization Template" icon="pi pi-download" />
                                    </div> 
                                </div> : null}
                                {stageField.filter(_ => _.parentFieldId === '000').map((field, fieldIndex) => {
                                   
                                    return <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : field.fieldDescription === "OT Hours" ? "p-col-12 p-md-8 p-lg-8" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldDescription === "OT Hours" ? <div className="p-grid">
                                            <div className="p-col-12 p-md-6 p-lg-6">
                                                <Inputs
                                                    field={field}
                                                    value={field.fieldValue}
                                                    process={process}
                                                    onInputChange={(e) => this.handleChange(e, field)}
                                                    {...this.props}
                                                    {...this.state} />
                                            </div>
                                            <div className="noLableMargin p-col-12 p-md-6 p-lg-6" style={{ marginTop: '2.9em' }}>
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={ () => this.initialize(this.state.initialData, 'progress')} label="Initiate Process" icon="pi pi-upload" />
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null ) ? true : false} onClick={() => this.initialize(this.state.initialData, 'add')} className="ml1 p-button-info" label="Reset" icon="pi pi-refresh" />
                                            </div>
                                        </div> : <Inputs
                                                field={field}
                                                value={(field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',')) || (field.fieldDescription === "Employees" && employees && employees.length > 0 && employees.split(',')) || field.fieldDescription === 'From Date' && !field.fieldValue && fromDate || field.fieldDescription === 'To Date' && !field.fieldValue && toDate || field.fieldDescription === 'Work Order No.' && !field.fieldValue && workorderno|| field.fieldDescription === 'Reason' && !field.fieldValue && Reason || field.fieldValue}
                                                process={process}
                                                onInputChange={(e) => this.handleChange(e, field)}
                                                {...this.props}
                                                {...this.state} />}
                                    </div>

                                })}

                                {this.state.processInitiated && 
                                <Accordion activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange.bind(this)}>
                                    {Object.keys(containers).map((emp, empIndex) => {
                                        const EmployeeField = containers[emp];
                                        const selEmployeeDet = empnew.find(_ => _.value === emp) || {};
                                        const totalHours = EmployeeField.reduce((a, el) => el.fieldDescription === 'Hours' && el.fieldValue ? a + parseInt(el.fieldValue) : a, 0);
                                        const Accemp = EmployeeField.reduce((a, el) => el.fieldDescription === 'Employee Id' && el.fieldValue ? el.fieldValue: a, '');
                                        const fname = EmployeeField.reduce((a, el) => el.fieldDescription === 'First Name' && el.fieldValue ? el.fieldValue: a, '');
                                        const mname = EmployeeField.reduce((a, el) => el.fieldDescription === 'Middle Name' && el.fieldValue ? el.fieldValue: a, '');
                                        const lname = EmployeeField.reduce((a, el) => el.fieldDescription === 'Last Name' && el.fieldValue ? el.fieldValue: a, '');
                                        const ename = emp + '-' + fname + ' ' + mname + ' ' + lname;
                                       
                                        //const usedhour = this.fusedhour(emp);
                                        return <AccordionTab key={empIndex} header={`${ename}`}>
                                            <div className="p-grid">
                                                {EmployeeField.map((field, fieldIndex) => {
                                                    return <div key={fieldIndex} className={"p-col-12 p-md-4 p-lg-2"}>
                                                        <Inputs
                                                            field={field}
                                                            value={field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',') || field.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, field)}
                                                            {...this.props}
                                                            {...this.state} />
                                                    </div>
                                                })}
                                            </div>
                                        </AccordionTab>
                                    })}
                                </Accordion>}

                                {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'Moblization'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) != stageIndex&& pendingWith !== null) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence&& pendingWith !== null) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Link to={'/Moblization'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <div className="p-col-12 p-md-6 p-lg-6">
                                        <label className="label">
                                            Vendor <span className="requiredColor">*</span>
                                        </label>
                                        <div className="mt1"></div>
                                        <MultiSelect
                                            className="p-col-12"
                                            placeholder="Select Employees"
                                            options={supplieroptions} // Pass the list of options
                                            value={this.state.vendors}    // Bind to the selected values in state
                                            onChange={(e) => this.Change(e)} // Update state on selection
                                            name="vendors"                 // Name of the field
                                            {...DROPDOWN_CONFIG}            // Spread additional configuration
                                            display="chip" 
                                            style={{ height: "60px" }}   
                                            panelStyle={{ maxHeight: '200px', overflowY: 'auto' }}              // Optional: Display selected values as chips
                                        />
                                        </div>
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0&& pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(status && pendingWith !== null ? false : true)}onClick={() => this.downloadPDF('download')} className="p-button-success ml1" label="DownloadPDF" icon="pi pi-download" />       
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0&& pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed'&& pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith !== null ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />
                                        <Link to={'/Moblization'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}

                            </div>
                        </div>
                    </div>
                })}


                <Dialog header="Select Supervisor" visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">Select Supervisor<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder="Select Supervisor" name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }
}

const mapStateToProps = (state, props) => {

    const pageType = props.match.params.type;
    const emplist = state?.master?.keywordValuesList?.map(e => ({...e, value:e.uniqueId})) || []
    const subordinatesList = pageType === 'edit' && state.master.requestAttributeData  ? ([Object.assign({}, { label: `${state.master.requestAttributeData.employeename} (Self)`, value: state.master.requestAttributeData.employeeID })]).concat(state.master.subordinatesListData) : ([Object.assign({}, { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, userId: state.auth.userObject.userID })]).concat(state.master.subordinatesListData);
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData: subordinatesList,
        keywordValuesList,
        metaData: Object.assign({}, {
            Shift: state.keyword.Shift,
            'Shift': state.keyword.Shift,
            'Employees': subordinatesList,
            'Requested For': subordinatesList,
            'Employee Id': emplist,
            'OT Type': state.keyword.OTType,

            'Employee Group': state.keyword.employeegroup,
            'Employee Sub Group': state.keyword.employeesubgroup,
            'Payroll Area': state.keyword.payrollarea,

            'Cost Center': state.keyword.CostCenter,
            'Project': state.keyword.Project,
            'Supplier': state.keyword.Vendor,
            'Employee Type': state.keyword.EMPLOYEETYPE,
           // 'Contract Type': state.keyword.costcenter,
            'Salary Type': state.keyword.PayType,
            'Category': state.keyword.EmpCategory,
            'Grade': state.keyword.EmpGrade,
            'Working Division (Pers Sub Area)':state.keyword.EmpPersSubArea,
            'Gender': state.keyword.GENDER,
            'Department': state.keyword.Orgunit,
            'Nationality': state.keyword.nationality,
            'Position': state.keyword.position,
            'Project': state.keyword.Project,
            'Shift Pattern': state.keyword.ShiftPattern,
            
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Moblization);